import styled from '@emotion/styled';
import {motion} from 'framer-motion';

export const IconWrapper = styled(motion.div)`
  height: 4em;

  @media (min-width: 600px) {
    height: 7em;
  }
`;
